var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_11988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 6.99967C5.86667 6.99967 6.91667 5.94967 6.91667 4.66634C6.91667 3.38301 5.86667 2.33301 4.58333 2.33301C3.3 2.33301 2.25 3.38301 2.25 4.66634C2.25 5.94967 3.3 6.99967 4.58333 6.99967ZM6.91667 11.6663V8.57467C6.275 8.34134 5.45833 8.16634 4.58333 8.16634C2.30833 8.16634 0.5 9.21634 0.5 10.4997V11.6663H6.91667ZM13.3333 2.33301H9.25C8.60833 2.33301 8.08333 2.85801 8.08333 3.49967V10.4997C8.08333 11.1413 8.60833 11.6663 9.25 11.6663H13.3333C13.975 11.6663 14.5 11.1413 14.5 10.4997V3.49967C14.5 2.85801 13.975 2.33301 13.3333 2.33301ZM11 10.4997H9.83333V3.49967H11V10.4997Z",
    fill: "#8D1912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_11988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentinfo);
export default __webpack_public_path__ + "static/media/paymentinfo.9dd8743c45ae87f24760493b440e19fd.svg";
export { ForwardRef as ReactComponent };